import { checkIsSideBackgroundDark, getCSSVariable } from '@/util/colorUtils'
import { reactive, ref } from 'vue'

export class Themes {
  state = reactive({
    windowGradient: true,
    isDarkMode: false,
    isSideBarBackgroundDark: ref(checkIsSideBackgroundDark()),
    isBackgroundSideBarColorSame: ref(
      getCSSVariable('--background') === getCSSVariable('--sidebar-background')
    ),
  })

  updateIsBackgroundSideBarSame(): void {
    this.state.isBackgroundSideBarColorSame =
      getCSSVariable('--background') === getCSSVariable('--sidebar-background')
  }
}
export const Theme = new Themes()
